import EA from 'helpers/init';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default EA.Methods.fadeMobileAnim = ($this) => {
    const anim = $this.querySelectorAll('.fade-mobile');
    const mm = gsap.matchMedia();
    mm.add('(max-width: 1200px)', () => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: $this,
                start: '0 80%'
            }
        });

        gsap.config({nullTargetWarn: false});

        tl
            .from(anim, {
                y: 30,
                alpha: 0,
                duration: 0.6,
                stagger: 0.2,
                ease: 'power3.inOut',
                clearProps: 'all'
            });
    });

};
